(()=>{
const country=document.documentElement.dataset.pvCountry||'SE';
const imperial=country==='US';
const locale=document.documentElement.lang||'en';
const number=value=>{try{return new Intl.NumberFormat(locale,{maximumFractionDigits:2}).format(Number(value.replace(',','.')));}catch{return value;}};
const format=value=>{
 const text=String(value||'');
 if(text.includes(' · '))return text.split(' · ').map(format).join(' · ');
 const metric=text.match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*cm/i);
 const inches=text.match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*(?:["″”]|in\b|inch)/i);
 const match=imperial?inches:metric;
 if(!match)return text;
 return number(match[1])+' × '+number(match[2])+(imperial?' in':' cm');
};
window.PVSizeLabel=format;
const selector='.pv-fp-dd-size,.pv-fp-dd-item-size,.pv-quick-size>span,[data-pv-sizes]>button,.pv-product-facts dd';
function update(scope){if(scope.nodeType!==1&&scope.nodeType!==9)return;const nodes=[...(scope.matches?.(selector)?[scope]:[]),...scope.querySelectorAll(selector)];nodes.forEach(el=>{const label=format(el.textContent);if(label!==el.textContent)el.textContent=label;});}
update(document);
let pending=new Set(),queued=false;
new MutationObserver(records=>{records.forEach(r=>{if(r.type==='characterData')pending.add(r.target.parentElement);else {pending.add(r.target);r.addedNodes.forEach(n=>{if(n.nodeType===1)pending.add(n);});}});if(!queued){queued=true;queueMicrotask(()=>{queued=false;const batch=[...pending];pending.clear();batch.forEach(update);});}}).observe(document.body,{childList:true,subtree:true,characterData:true});
})();
